





































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { PageModule } from "@/store/module/page";
import {
  getLatentStudentListData,
  getLatentStudentListApi,
  latentListExport,
} from "@/api/studentManage";
import {
  getActivitySelectListApi,
  getMarketStaffListApi,
} from "@/api/marketActivity";
import eventBus from "@/utils/bus";
import detailsDialog from "../../../teachManagement/studentManage/studyDetails/detailsDialog.vue";
import { getFollowLatentApi, getFollowStageApi } from "@/api/studentFollow";
import addDialog from "./addDialog.vue";
import { subjectList } from "@/api/subject";
import mutiEditDialog from "./mutiEditDialog.vue";
import uploadTableDialog from "./uploadTableDialog.vue";
import { dateFormat } from "@/utils/timeFormat";
import { Vue, Component } from "vue-property-decorator";
import { exportLoop } from "@/utils/export";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import commonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
import {
  getStudentAppearListApi,
  sourceTypeSelectListApi,
} from "@/api/storeManagement";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

@Component({
  name: "latentStudent",
  components: {
    addDialog,
    mutiEditDialog,
    uploadTableDialog,
    detailsDialog,
    commonStaffPullDown,
    commonSearchFormWrapper,
    commonDateRangeSelector,
  },
})
export default class extends Vue {
  topSearchInfo = {
    distribute_status: "all",
    quick: "all",
  };
  searchInfo: any = {
    degree_of_interest: [] as number[],
    date: [],
    follow_status: [],
    follow_time: [],
    sort_type: "desc",
    sort_field: "create_time",
    market_staff_id: "",
    follow_staff_id: "",
    follow_staff_list: [],
    create_staff_id: "",
    create_staff_list: [],
    allocate_num_start: "",
    allocate_num_end: "",
  };
  studentInfo = {}; // 学生信息
  showDialog = false; //弹框开关
  dialogidetailsid = 0; //弹框id
  dialogType = ""; //弹框类型
  subjectsList: any[] = [];
  sourceList: any[] = [];
  followLatent: any[] = [];
  followLatentObj: {} = {};
  followStageObj: {} = {};
  followStageList: any[] = [];
  tableData: any[] = [];
  multipleSelection: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  activityTitleList: any[] = [];
  market_staff_list: any[] = [];
  options: { label: string; value: number }[] = [
    {
      label: "已跟进",
      value: 1,
    },
    {
      label: "未分配",
      value: 2,
    },
    {
      label: "待跟进",
      value: 3,
    },
  ];
  followStatus = {
    1: "已跟进",
    2: "已跟进",
    3: "已逾期",
    4: "已取消",
  };
  studentAppearLabelList: any[] = [];
  created() {
    eventBus.$on("latent-list-update-latent", () => {
      const table: any = this.$refs["main-table"];
      table.clearSelection();
      this.handleRefresh();
    });
    if (
      PageModule.latestRoute === "studyDetails" ||
      PageModule.latestRoute === "buyCourseConfirm"
    ) {
      const cache = PageModule.pageInfo.recruitLatentList;
      if (cache.page) {
        this.page = cache.page;
      }
      if (cache.page_size) {
        this.pageSize = cache.page_size;
      }
      if (cache.search_info) {
        this.searchInfo = cache.search_info;
      }
    } else if (PageModule.latestRoute === "dashboard") {
      // 来自首页
      const params = this.$route.params;
      if (params.start_time && params.end_time) {
        this.searchInfo.date = [params.start_time, params.end_time];
      }
    }
    this.getList({
      page: this.page,
      page_size: this.pageSize,
    });
    this.getActivitySelectList();
    getFollowLatentApi().then((res: any) => {
      this.followLatent = res.data.list;
      const obj: any = {};
      res.data.list.map((item: any) => {
        obj[item.key] = item.value;
      });
      this.followLatentObj = obj;
    });
    getFollowStageApi({ include_del: 1 }).then((res: any) => {
      let obj: any = {};
      res.data.list.map((item: any) => {
        obj[item.key] = item.value;
      });
      this.followStageObj = obj;
      this.followStageList = res.data.list;
    });
    subjectList({
      page: 1,
      page_size: 100,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.subjectsList = [...res.data.list];
      }
    });
    getStudentAppearListApi({
      page: 1,
      page_size: 500,
    }).then((res) => {
      this.studentAppearLabelList = res.data.list;
    });
  }
  handleAppear(scope: any) {
    let target = this.studentAppearLabelList.find((item: any) => {
      return scope.row.appear_id === item.id;
    });
    if (target) {
      return target.name;
    } else {
      return "-";
    }
  }
  handleQuickSearch(type: string) {
    this.topSearchInfo.quick = type;
    this.handleSearch();
  }
  // 活动名称列表
  getActivitySelectList(v?: any) {
    getActivitySelectListApi({
      page: 1,
      page_size: 100,
      title: v,
      activity_status_arr: [2, 3],
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.activityTitleList = res.data.list;
      }
    });
  }
  // 模糊搜索 - 活动名称
  handleSearchTitle(v: any) {
    this.getActivitySelectList(v);
  }
  // 列表下拉
  handleVisible(v: any) {
    if (v) {
      this.getActivitySelectList();
    }
  }
  // 获取市场顾问列表
  getMarketStaffList(v?: any) {
    getMarketStaffListApi({
      page: 1,
      page_size: 100,
      keyword: v,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.market_staff_list = res.data.list;
      }
    });
  }
  // 模糊搜索 - 市场顾问
  handleSearchMarketStaff(v: any) {
    this.getMarketStaffList(v);
  }
  // 市场顾问列表下拉
  handleMarketStaffVisible(rest: any) {
    if (rest) {
      this.getMarketStaffList();
    }
  }
  toCreateSechdule(data: any) {
    PageModule.SET_PAGE_INFO({
      name: "recruitExperienceList",
      key: "selected_student",
      value: {
        avatar_url: data.avatar_url,
        is_del: data.is_del,
        mobile: data.mobile,
        name: data.name,
        org_id: data.org_id,
        sex: data.sex,
        status: data.status,
        student_id: data.student_id,
      },
    });
    this.$router.push({
      name: "experienceSechdule",
      query: {
        sid: data.student_id,
        sname: data.name,
      },
    });
  }
  resetSearch() {
    this.searchInfo = {
      degree_of_interest: [],
      date: [],
      follow_status: [],
      sort_type: this.searchInfo.sort_type,
      sort_field: this.searchInfo.sort_field,
      market_staff_id: "",
      follow_staff_id: "",
      follow_staff_list: [],
      create_staff_id: "",
      create_staff_list: [],
    };
    this.page = 1;
    this.pageSize = 10;
    this.getList({
      page: this.page,
      page_size: this.pageSize,
    });
    this.savePageInfo();
  }
  followContent(data: any, type: string, info: any) {
    this.studentInfo = info;
    this.showDialog = true;
    this.dialogType = type;
    this.dialogidetailsid = data;
  }
  dialogHide(e: string) {
    this.showDialog = false;
    if (e == "add" || e == "followUp") {
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    }
  }
  handleSearch(evt?: any) {
    if (evt === "appear") {
      if (this.searchInfo.appear_id) {
        sourceTypeSelectListApi({ appear_id: this.searchInfo.appear_id }).then(
          (res: any) => {
            this.sourceList = res.data.list;
          }
        );
      } else {
        this.sourceList = [];
      }
      this.searchInfo.source_type = "";
    }
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  handleRefresh() {
    this.getList({
      page: this.page,
      page_size: this.pageSize,
    });
  }
  solveSearchParams() {
    let option: getLatentStudentListData = {};
    if (this.searchInfo.key_word) {
      option.key_word = this.searchInfo.key_word;
    }
    if (this.searchInfo.sex !== "") {
      option.sex = this.searchInfo.sex;
    }
    if (this.searchInfo.source_type !== "") {
      option.source_type = this.searchInfo.source_type;
    }
    if (this.searchInfo.appear_id !== "") {
      option.appear_id = this.searchInfo.appear_id;
    }
    if (this.searchInfo.subject_id !== "") {
      option.subject_id = this.searchInfo.subject_id;
    }
    if (this.searchInfo.follow_staff_id !== "") {
      option.follow_staff_id = this.searchInfo.follow_staff_id;
    }
    if (this.searchInfo.create_staff_id !== "") {
      option.create_staff_id = this.searchInfo.create_staff_id;
    }
    if (this.searchInfo.date && this.searchInfo.date.length === 2) {
      option.start_time =
        new Date(this.searchInfo.date[0]?.replace(/-/g, "/")).getTime() / 1000;
      option.end_time =
        (new Date(this.searchInfo.date[1]?.replace(/-/g, "/")).getTime() +
          24 * 60 * 60 * 1000 -
          1000) /
        1000;
    }
    if (
      this.searchInfo.follow_time &&
      this.searchInfo.follow_time.length === 2
    ) {
      option.follow_start_time = this.searchInfo.follow_time[0];
      option.follow_end_time = this.searchInfo.follow_time[1];
    }
    if (this.searchInfo.allocate_num_start) {
      option.allocate_num_start = Number(this.searchInfo.allocate_num_start);
    }
    if (this.searchInfo.allocate_num_end) {
      option.allocate_num_end = Number(this.searchInfo.allocate_num_end);
    }
    if (this.searchInfo.acquisition_time) {
      option.acquisition_start_time = this.searchInfo.acquisition_time[0];
      option.acquisition_end_time = this.searchInfo.acquisition_time[1];
    }
    if (this.searchInfo.degree_of_interest.length > 0) {
      option.intent_arr = this.searchInfo.degree_of_interest;
    }
    if (this.searchInfo.follow_status.length > 0) {
      option.follow_status = this.searchInfo.follow_status;
    }
    if (this.searchInfo.stage !== "") {
      option.stage = this.searchInfo.stage;
    }
    if (this.searchInfo.sort_type !== "" && this.searchInfo.sort_field !== "") {
      option.sort_type = this.searchInfo.sort_type;
      option.sort_field = this.searchInfo.sort_field;
    }
    if (this.searchInfo.age_stage > 0) {
      option.age_stage = this.searchInfo.age_stage;
    }
    if (this.searchInfo.market_staff_id) {
      option.market_staff_id = this.searchInfo.market_staff_id;
    }
    if (this.searchInfo.activity_id) {
      option.market_activity_id = this.searchInfo.activity_id;
    }
    if (this.searchInfo.remark) {
      option.remark = this.searchInfo.remark;
    }
    if (this.topSearchInfo.distribute_status !== "all") {
      option.follow_staff_filtering = this.topSearchInfo.distribute_status;
    }
    if (this.topSearchInfo.quick !== "all") {
      option.quick_filtering = this.topSearchInfo.quick;
    }
    return option;
  }
  clickexport() {
    let data: any = this.solveSearchParams();
    latentListExport(data).then((res: any) => {
      if (res.error_code === 0) {
        exportLoop(res.data.task_id);
      } else {
        this.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  getList(params: { page: number; page_size: number }) {
    const option: getLatentStudentListData = {
      page: params.page,
      page_size: params.page_size,
      ...this.solveSearchParams(),
    };
    if (this.searchInfo.sort_type !== "") {
      option.sort_type = this.searchInfo.sort_type;
    }
    if (this.searchInfo.sort_field !== "") {
      option.sort_field = this.searchInfo.sort_field;
    }
    getLatentStudentListApi(option).then((res: any) => {
      res.data.list = res.data.list || [];
      this.page = res.data.page;
      this.total = res.data.total;
      const today = new Date().getTime();
      res.data.list.map((item: any) => {
        if (item.create_time) {
          item.create_time = dateFormat("YYYY-mm-dd", item.create_time * 1000);
        } else {
          item.create_time = "-";
        }
        if (item.allocate_time) {
          item.allocate_time = dateFormat(
            "YYYY-mm-dd",
            item.allocate_time * 1000
          );
        } else {
          item.allocate_time = "-";
        }
        if (item.follow_time) {
          item.follow_time = dateFormat("YYYY-mm-dd", item.follow_time * 1000);
        } else {
          item.follow_time = "-";
        }
        if (item.acquisition_time) {
          item.acquisition_time = dateFormat(
            "YYYY-mm-dd",
            item.acquisition_time * 1000
          );
        } else {
          item.acquisition_time = "-";
        }
        item.format_last_follow_time = "-";
        item.format_next_follow_time = "-";
        if (item.follow_log) {
          item.format_last_follow_time =
            item.follow_log.follow_time === 0
              ? "-"
              : dateFormat(
                  "YYYY-mm-dd HH:MM",
                  item.follow_log.follow_time * 1000
                );
          item.format_next_follow_time =
            item.follow_log.pre_follow_time === 0
              ? "-"
              : dateFormat(
                  "YYYY-mm-dd HH:MM",
                  item.follow_log.pre_follow_time * 1000
                );
        }
        if (item.age === 0) {
          if (item.birthday !== 0) {
            const severalMonths = today - item.birthday * 1000;
            item.age = new Date(severalMonths).getMonth() + "个月";
          } else {
            item.age = "-";
          }
        } else {
          item.age = item.age + "岁";
        }
      });
      this.tableData = res.data.list;
      if (res.data.page > 1 && res.data.list.length === 0) {
        this.handleSearch();
      }
    });
  }
  handleSelectionChange(arr: any[]) {
    this.multipleSelection = arr;
  }
  handlePay(row: any) {
    this.$confirm(
      "意向学员在完成缴费后，会自动转化为在读学员，同时跟进状态自动变为已成交，确定前往缴费？",
      `缴费 - ${row.name}`,
      {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        type: "warning",
      }
    )
      .then(() => {
        this.savePageInfo();
        this.$router.push({
          name: "buyCourseConfirm",
          query: { id: String(row.id) },
        });
      })
      .catch(() => {});
  }
  handleFollow(id: number) {
    this.savePageInfo();
    this.$router.push({
      name: "studyDetails",
      query: { id: String(id), tab: "followup" },
    });
  }
  savePageInfo() {
    PageModule.SET_PAGE_INFO({
      name: "recruitLatentList",
      key: "page",
      value: this.page,
    });
    PageModule.SET_PAGE_INFO({
      name: "recruitLatentList",
      key: "page_size",
      value: this.pageSize,
    });
    PageModule.SET_PAGE_INFO({
      name: "recruitLatentList",
      key: "search_info",
      value: this.searchInfo,
    });
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
  // 排序
  clickStort(e: { order: string; prop: string }) {
    this.searchInfo.sort_field = e.prop;
    // 后端反馈该排序字段更新为 follow_time
    if (e.prop === "format_last_follow_time") {
      this.searchInfo.sort_field = "follow_time";
    }
    if (e.order == "descending") {
      this.searchInfo.sort_type = "desc";
    } else if (e.order == "ascending") {
      this.searchInfo.sort_type = "asc";
    } else {
      this.searchInfo.sort_type = "";
    }
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  beforeDestroy() {
    eventBus.$off("latent-list-update-latent");
  }
}
